import revgen from './src/index.js';

if (!window.AdManager) {
    window.AdManager = revgen.initialize();
    window.dispatchEvent(new Event('adManagerInitialized'));
}
